import React, { useState } from "react";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("idle"); // idle | submitting | success | error
  const [error, setError] = useState("");

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

    const onSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      setError("Please fill in your name, email, and message.");
      return;
    }

    setStatus("submitting");
    try {
      const payload = {
        kind: "homeowner",
        name: form.name.trim(),
        email: form.email.trim() || "",
        phone: form.phone.trim() || "",
        zip: "", // contact page doesn't collect ZIP
        service: "", // not specified here
        details: form.message.trim(),
        source: "site_contact_v1",
      };

      const res = await fetch(
        "https://api.buildbright.app/admin/proxy/leads?allow=1",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      let data = null;
      try {
        data = await res.json();
      } catch {
        data = null;
      }

      if (!res.ok) {
        console.error("Contact submit HTTP error:", res.status, data);
        throw new Error(`Request failed (${res.status})`);
      }

      if (data && data.ok === false) {
        console.error("Contact submit logical error:", data);
        throw new Error(data.message || "We couldn't save your message.");
      }

      setForm({ name: "", email: "", phone: "", message: "" });
      setStatus("success");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      console.error("Contact submit error:", err);
      setError(
        err.message || "Something went wrong. Please try again."
      );
      setStatus("error");
    }
  };


  const disabled = status === "submitting";

  return (
    <div className="mx-auto max-w-3xl px-4 py-10">
      {status === "success" && (
        <div className="mb-4 rounded-md border border-emerald-200 bg-emerald-50 px-4 py-3 text-emerald-800">
          Message sent! We’ll reach out within 1 business day.
        </div>
      )}

      <h1 className="mb-2 text-3xl font-bold">Contact Us</h1>
      <p className="mb-8 text-zinc-300">
        Tell us a bit about your project and we’ll get back to you.
      </p>

      {error && (
        <div className="mb-4 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-red-700">
          {error}
        </div>
      )}

      <form onSubmit={onSubmit} className="space-y-5">
        <div>
          <label className="mb-1 block text-sm font-medium">Name*</label>
          <input
            name="name"
            value={form.name}
            onChange={onChange}
            className="w-full rounded-lg border border-zinc-700 px-3 py-2 outline-none focus:border-emerald-500"
            placeholder="Your full name"
          />
        </div>

        <div className="grid gap-5 md:grid-cols-2">
          <div>
            <label className="mb-1 block text-sm font-medium">Email*</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={onChange}
              className="w-full rounded-lg border border-zinc-700 px-3 py-2 outline-none focus:border-emerald-500"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium">Phone</label>
            <input
              name="phone"
              value={form.phone}
              onChange={onChange}
              className="w-full rounded-lg border border-zinc-700 px-3 py-2 outline-none focus:border-emerald-500"
              placeholder="(optional)"
            />
          </div>
        </div>

        <div>
          <label className="mb-1 block text-sm font-medium">Message*</label>
          <textarea
            name="message"
            value={form.message}
            onChange={onChange}
            rows={5}
            className="w-full rounded-lg border border-zinc-700 px-3 py-2 outline-none focus:border-emerald-500"
            placeholder="What do you need help with?"
          />
        </div>

        <div className="pt-2">
          <button
            type="submit"
            disabled={disabled}
            className={`inline-flex items-center rounded-xl bg-emerald-600 px-5 py-2.5 font-medium text-white shadow-sm transition ${
              disabled ? "opacity-60" : "hover:bg-emerald-700"
            }`}
          >
            {disabled ? "Sending…" : "Send message"}
          </button>
          <p className="mt-2 text-[11px] text-zinc-400">
    By submitting, you agree to receive SMS updates about your project
    from BuildBright and to be contacted by matching contractors by
    phone, text, or email. Reply STOP to opt out of SMS.
  </p>
        </div>
      </form>
    </div>
  );
}

